import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahjournalismandmasscommunication',
  templateUrl: './asahjournalismandmasscommunication.component.html',
  styleUrls: ['./asahjournalismandmasscommunication.component.scss']
})
export class AsahjournalismandmasscommunicationComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
